import { List as ImmutableList } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { fetchGenericChannels as requestFn } from '../clients/fetchGenericChannels';
import { FETCH_GENERIC_ACCOUNTS as actionTypes } from '../constants/asyncActionTypes';
export const fetchGenericChannels = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: ImmutableList
});